// extracted by mini-css-extract-plugin
export default {"image-link":"NCEmXH","imageLink":"NCEmXH","action":"vlDbWO","content":"ehrTQL","aligned-box":"t0lL0E","alignedBox":"t0lL0E","title":"o4Fpaa","info":"YIZbrz"};